import React from "react";

function Services() {
    return (
        <React.Fragment>
            <div>This is Services section.</div>
        </React.Fragment>
    );
}

export default Services;
